import {AxiosError} from 'axios';
import get          from 'lodash/get';
import forEach      from 'lodash/forEach';
import qs           from 'qs';
import moment       from 'moment-timezone';

import router       from '@/router';
import {Enum}       from '@/app/shared/enum/enum';
import {Message}    from '@/app/shared/model/message.model';
import CheckService from '@/app/account/shared/service/check.service';

export default class UtilService {
  private timer!: any;
  private checkService = new CheckService();

  safeCall(parent: any, key: string) {
    return get(parent, key);
  }

  dateToFormatDate(date: Date | string): string {
    // const dateObj = new Date(date);
    // return `${dateObj.getFullYear()}.${dateObj.getMonth() + 1}.${dateObj.getDate()}`;
    return moment(date)
      .format('YYYY.MM.DD');
  }

  getEnumName(enums, key: string) {
    let returnVal = '';
    if (!!enums[`NAME_${key}`]) {
      returnVal = enums[`NAME_${key}`];
    }
    return returnVal;
  }

  setNumberToString(num: number): string {
    let returnValue = '';

    if (num !== null && num !== undefined) {
      if (num >= 10) {
        returnValue = num.toString();
      } else {
        returnValue = `0${num}`;
      }
    }

    return returnValue;
  }

  makeQueryStringUrl(url: string, params: any): string {
    let returnValue = url;

    if (!!params) {
      const queryString = qs.stringify(this.optimizeParams(params), {encoding: false, allowDots: true});
      if (!!queryString) {
        returnValue = `${returnValue}?${queryString}`;
      }
    }

    return returnValue;
  }

  optimizeParams(params: any): any {
    forEach(params, (value, key) => {
      if (!value) {
        delete params[key];
      }
    });

    return params;
  }

  onTimer(callback: () => any) {
    if (!!this.timer) {
      clearInterval(this.timer);
    }

    this.timer = setInterval(() => {
      callback();
      clearInterval(this.timer);
    }, Enum.CORE.TIMER.SECOND / 2);
  }

  onErrorAsPlatform(joinCode: Enum.ACCOUNT.CHECK.JOIN_CODE) {
    if (this.checkService.isPc(joinCode)) {
      window.location.href = `${process.env.VUE_APP_GENIE_PC_WEB_DOMAIN}`;
    } else if (this.checkService.isMobile(joinCode)) {
      window.location.href = `${process.env.VUE_APP_GENIE_MOBILE_WEB_DOMAIN}`;
    } else if (this.checkService.isApp(joinCode)) {
      // @ts-ignore
      executeApp('19', '', false, 'A');
    }
  }

  defaultAxiosError(error: AxiosError, errorCallback?: () => any) {
    if (!!error.response && error.response.status === 401) {
      this.tokenExpireErrorCallBack();
    } else if (!!error.response && error.response.status === 406) {

      switch (error.response?.data?.code) {
        case 'E00100205' :
          window.alert(`${error.response.data.message}`);
          // @ts-ignore
          executeApp('19', '', false, 'A');
          break;
        case 'E00100206' : window.alert(`${error.response.data.message}`); break;
        default : window.alert(Message.ALERT.ACCESS_DENIED); break;
      }

      if (!!errorCallback) {
        errorCallback();
      }
    } else {
      window.alert(Message.ALERT.ACCESS_DENIED);

      if (!!errorCallback) {
        errorCallback();
      }
    }
  }

  tokenExpireErrorCallBack() {
    window.alert(Message.ALERT.TOKEN_EXPIRED);
    const toName = this.tokenErrorTargetUrl();

    if (window.location.pathname === toName) {
      window.location.reload();
    } else {
      router.push(toName);
    }
  }

  tokenErrorTargetUrl(): string {
    let backPath = '';
    const pathName = window.location.pathname;

    const createPathList = [
      '/account/create/agree',
      '/account/create/agree-agent',
      '/account/create/forms',
      '/account/create/forms-sns',
      '/account/create/forms-ctn',
      '/account/create/result'
    ];

    const findIdPathList = [
      '/account/find/confirm-id',
      '/account/find/confirm-auth/id/ipin',
      '/account/find/confirm-auth/id/mobile',
      '/account/find/result-id'
    ];

    const findPwPathList = [
      '/account/find/confirm-pw',
      '/account/find/confirm-auth/pw/ipin',
      '/account/find/confirm-auth/pw/mobile',
      '/account/find/change-pw',
      '/account/find/result-pw-error',
      '/account/find/result-pw'
    ];

    const socialTransferList = [
      '/account/social-transfer/account-social-transfer-confirm-id',
      '/account/social-transfer/account-social-transfer-result-id',
      '/account/social-transfer/account-social-transfer-form',
      '/account/social-transfer/account-social-transfer-complete'
    ];

    createPathList.forEach((path: string) => {
      if (path === pathName) {
        backPath = createPathList[0];
      }
    });

    findIdPathList.forEach((path: string) => {
      if (path === pathName) {
        backPath = findIdPathList[0];
      }
    });

    findPwPathList.forEach((path: string) => {
      if (path === pathName) {
        backPath = findPwPathList[0];
      }
    });

    socialTransferList.forEach((path:string) => {
      if (path === pathName) {
        backPath = socialTransferList[0];
      }
    });

    return backPath;
  }

  xssDecode(str:string) {
     return str.replaceAll('&lt;', '<')
               .replaceAll('&gt;','>')
               .replaceAll('&quot;', '\"')
               .replaceAll('&amp;', '&')
               .replaceAll('&#39;', '\\');
  }
}
